export const pricingToggleContent = {
    es: { screen: '1 Pantalla', multi: 'Multi-pantallas' },
};
